import { faCheck, faClose, faPencil, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { MultiSelect } from 'primereact/multiselect'
import { Toast } from 'primereact/toast'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCertDetailValues,
  selectModelDetailValues,
  selectModelList,
  selectOwnerReference,
  selectPartySiteNumber,
  setModelsProductStandardsUpdates,
  selectStandardValue,
  selectStandardOptions,
  selectProductCategoryStandards,
  updateHasExistingModels,
  updateModelDetails,
  updateModelList,
  updateProdDetailsModelList,
  updateProdDetailsRemarks,
  updateStandardOptions,
  updateStandardValues,
  updateHasEmptyProductStandardRow,
  updateCertDetailsFormValues,
  selectSchemeEcmType,
  updateTempStandardOptions,
  updateIsModelOnEdit,
  selectedCertHasSecondary as selectCertHasSecondary,
  updateSecondaryStandardValues,
  updateTempSecondaryStandardOptions,
  selectSecondaryStandardOptions,
  selectSelectedProductCategory,
  selectSecondaryStandardValue,
  selectCopyState,
  selectCertificateSchemeFromFormValues as selectedCertificateScheme,
  selectAssetDocuments,
  updateAssetDocuments,
  selectCertificateSubprogram,
  deleteAssetDocuments,
} from '../../../../features/createCertificate/createCertificateSlice'
import DocumentService from '../../../../services/DocumentService'
import ModelSearch from '../../../../shared/model-search/ModelSearch'
import { sortList } from '../../../../utils/helpers/array.helpers'
import classes from './CertificateModelSection.module.scss'
import './CertificateModelSection.scss'
import { uniqBy, orderBy, flatten } from 'lodash'
import {
  getAttributeUniqueName,
  CertificateGroupEnum,
  CERTIFICATE_SCHEME,
  CERTIFICATE_MARK_WITHOUT_IMAGE_COLUMNNS,
} from '../../../../utils/constants/certificate.constants'
import CertificateListService from '../../../../services/CertificateListService'

import BulkSaveConfirmationDialog from '../add-new-certificate/add-new-cert-prod-details/bulk-save-confirmation-dialog/BulkSaveConfirmationDialog'
import { ProductStandardUtils } from '../add-new-certificate/add-new-cert-prod-details/utils/product-standard-utils'
import SecondaryStandardTemplate from '../add-new-certificate/add-new-cert-prod-details/secondary-standard-template/SecondaryStandardTemplate'
import CloseRowEditModeConfirmationDialog from '../add-new-certificate/add-new-cert-prod-details/close-row-edit-mode-confirmation-dialog/CloseRowEditModeConfirmationDialog'
import ModelUploadColumn from './name-plate-upload/ModelUploadColumn'
import { MODEL_UPLOAD_COLUMN } from '../../../../utils/constants/model-section.constants'
import { AssetDocument } from './name-plate-upload/assetDocumentsInterfaces'
import ProductRatingIcon from '../../../../shared/model-search/product-rating-icon/ProductRatingIcon'

const MIN_MODEL_DISPLAY = 7

const CertificateModelSection = (props: any) => {
  const dispatch = useDispatch()
  const certDetailsValues = useSelector(selectCertDetailValues)
  const {
    isSavingCertificate,
    isEditCert,
    isModifyCert,
    setFormValues,
    certificateId,
    currentStep,
    setIsModelInRowEditMode,
    setFormValidityMessages,
    hasRevisions,
  } = props
  const [selectedModels, setSelectedModels] = useState<any[]>([])
  const [selectedModelsForDeletion, setSelectedModelsForDeletion] = useState([])

  const tempAssetDocu = useSelector(selectAssetDocuments)
  const [remarks, setRemarks] = useState('')
  const partySiteNumberValue = useSelector(selectPartySiteNumber)
  const modelDetailValues = useSelector(selectModelDetailValues)
  const ownerReference = useSelector(selectOwnerReference)
  const models = useSelector(selectModelList)
  const standardValue = useSelector(selectStandardValue)
  const standardOptions = useSelector(selectStandardOptions)
  const secondaryStandardOptions = useSelector(selectSecondaryStandardOptions)
  const standardOptionsClone = useSelector(selectProductCategoryStandards)
  const secondaryStandardValue = useSelector(selectSecondaryStandardValue)
  const schemeEcmType = useSelector(selectSchemeEcmType)
  const certHasSecondary = useSelector(selectCertHasSecondary)
  const productType = useSelector(selectSelectedProductCategory)
  const isCopyModel = useSelector(selectCopyState)
  const certificateScheme = useSelector(selectedCertificateScheme)
  const certificateSubprogram = useSelector(selectCertificateSubprogram)

  const [modelSearchVisible, setModelSearchVisible] = useState(false)
  const [modelList, setModelList] = useState(models ?? [])
  const [standardList, setStandardList] = useState([])

  const [prevStandardLength, setPrevStandardLength] = useState(0)

  const [isBatchEditMode, setIsBatchEditMode] = useState(false)
  const batchEditRowData = {
    isEditMode: true,
    productStandards: [],
    isForBatchEdit: true,
  }

  const [columnFiles, setColumnFiles] = useState<any[]>([])

  const withoutImageColumns = CERTIFICATE_MARK_WITHOUT_IMAGE_COLUMNNS.includes(
    certificateSubprogram?.toLocaleLowerCase() ?? ''
  )

  const addColumnFile = (file: any) => {
    setColumnFiles((prev: any) => {
      const files = prev.filter(
        (f: any) => !(f.assetId === file.assetId && f.column === file.column)
      )
      return [...files, file]
    })
  }

  const updateColumFile = (assetId: string, objectURL: string, column: string) => {
    setColumnFiles((prev: any) =>
      prev.map((file: any) =>
        file.assetId === assetId && file.column === column ? { ...file, objectURL } : file
      )
    )
  }

  const deleteColumnFile = (assetId: string, column: string) => {
    setColumnFiles((prev: any) =>
      prev.map((file: any) =>
        file.assetId === assetId && file.column === column ? { ...file, isDeleted: true } : file
      )
    )
  }

  const isAnzCertificateScheme =
    certificateScheme?.toLocaleLowerCase() ===
    CERTIFICATE_SCHEME.ANZ_CERTIFICATION_SCHEME.toLocaleLowerCase()

  const multiSelectRef = useRef<MultiSelect>(null)

  const [modelsProductStandardsEditStates, setModelsProductStandardsEditStates] = useState<any>([])

  const rowsInEditMode = modelList?.filter((model: any) => model.isEditMode)
  const hasRowEditMode = rowsInEditMode?.length > 0 || isBatchEditMode
  const [closeRowEditModeConfirmationDialogVisible, setCloseRowEditModeConfirmationDialogVisible] =
    useState(false)
  const [pendingCloseRowsEditModesConfirmation, setPendingCloseRowsEditModesConfirmation] =
    useState([])
  const [bulkSaveConfirmationDialogVisible, setBulkSaveConfirmationDialogVisible] = useState(false)
  const [pendingBulkSaveEditModesConfirmation, setPendingBulkSaveEditModesConfirmation] = useState(
    []
  )

  const toast = useRef(null)
  const selectedModelsCount = selectedModels.length

  useEffect(() => {
    setIsModelInRowEditMode(hasRowEditMode)
  }, [])

  useEffect(() => {
    const modelDetail: any = {}
    if (models && models.length > 0) {
      let partySiteNumber = ''

      for (let i = 0; i < models.length; i++) {
        let isExists = models[i].taxonomy.find(
          (f: any) => f.dataParamName === 'ownerReference_PartySiteID'
        )

        if (isExists) {
          partySiteNumber = isExists.value
          break
        }
      }

      modelDetail.partySiteNumber = partySiteNumber
      modelDetail.productType = models[0].productType
      modelDetail.isDisable = true
    } else {
      modelDetail.partySiteNumber = ownerReference
      modelDetail.productType = null
      modelDetail.isDisable = false
    }

    dispatch(updateModelDetails(modelDetail))
    setModelList(models)
  }, [models, ownerReference])

  useEffect(() => {
    if (models?.length > 0 && modelList?.length > 0) {
      let newProductStandardOptions = uniqBy(
        [...certProductStandardOptions, ...certSecondaryProductStandardOptions],
        standard => standard.code
      )

      var standardList = newProductStandardOptions?.filter(
        x => standardValue?.includes(x.code) || secondaryStandardValue?.includes(x.code)
      )

      const newModelList = modelList.map((list: any) => {
        const newProductStandards =
          models.find((model: any) => model.assetId === list.assetId)?.productStandards ||
          standardList

        const newList = { ...list }
        newList.productStandards = newProductStandards
        newList.loadingProductStandards = false

        return newList
      })

      setModelList(newModelList)
    }
  }, [models])

  useEffect(() => {
    modelList.forEach((model: any) => {
      if (model.fetchedProductStandards) return

      setModelList((previousList: any) =>
        previousList.map((prevModel: any) => ({
          ...prevModel,
          fetchedProductStandards:
            prevModel.assetId === model.assetId || prevModel.fetchedProductStandards,
          loadingProductStandards:
            prevModel.assetId === model.assetId || prevModel.loadingProductStandards,
        }))
      )

      if (certificateId) {
        DocumentService.getIpCertificateProductStandard(certificateId, model.modelName)
          .then(result => {
            const certificateProductStandards =
              result?.data?.productStandards?.map((standards: any) => standards) || []

            const productStandards = certificateProductStandards
              .flat(1)
              ?.filter((standard: any) => standard)
              ?.map((standard: any) => ({
                code: standard.uniqueIdentifier,
                name: standard.standardLabel,
                schemeScopeStandardId: standard.pkSchemeScopeStandardId,
                ...standard,
              }))

            if (productStandards?.length > 0)
              setModelProductStandards(model.assetId, productStandards)
          })
          .finally(() => {
            setModelList((previousList: any) =>
              previousList.map((prevModel: any) => ({
                ...prevModel,
                loadingProductStandards:
                  prevModel.assetId === model.assetId ? false : prevModel.loadingProductStandards,
              }))
            )
          })
      } else {
        setModelList((previousList: any) =>
          previousList.map((prevModel: any) => ({
            ...prevModel,
            loadingProductStandards: false,
          }))
        )
      }
    })

    const disableProductStandardSaveActivate = !modelList.some(
      (x: any) => x.productStandards?.length
    )

    dispatch(updateHasEmptyProductStandardRow(disableProductStandardSaveActivate))
  }, [modelList])

  useEffect(() => {
    if (modelList.length > 0 && currentStep === 3) {
      const disableProductStandardSaveActivate = !modelList?.some(
        (x: any) => x.productStandards?.length
      )

      dispatch(updateHasEmptyProductStandardRow(disableProductStandardSaveActivate))
    }
  }, [currentStep])

  useEffect(() => {
    props.onSetRowEditMode && props.onSetRowEditMode(hasRowEditMode)
  }, [hasRowEditMode])

  useEffect(() => {
    if (!productType) return
    if (currentStep !== 2) return

    /**
     * Resetting this state when product type changed in step 2.
     */
    setModelsProductStandardsEditStates((prev: any) =>
      prev.map((item: any) => ({
        ...item,
        productStandards: [],
      }))
    )

    setModelList((prev: any) =>
      prev.map((item: any) => ({
        ...item,
        productStandards: [],
      }))
    )
  }, [productType])

  const mapper = (standard: any) => {
    return {
      pkSchemeScopeStandardId:
        standard.schemeScopeStandardId ??
        standard.value?.pkSchemeScopeStandardId ??
        standard.uniqueIdentifier ??
        standard.pkSchemeScopeStandardId,
      pkStandardId: standard.standardId,
      pkStandardLabelId: standard.standardLabelId,
      seq: standard.sequence,
      standardLevel: standard.standardLevel,
    }
  }

  useEffect(() => {
    const modelStandardUpdates = modelList
      .map((model: any) => {
        let toBeAdded = []
        let toBeRemoved = []

        const modelProductStandards = uniqBy(
          (model.productStandards ?? []).map((item: any) => ({
            ...item,
            code: item.code ?? item?.value?.pkSchemeScopeStandardId,
          })),
          (standard: any) => standard.code
        )

        if (isCopyModel.models) {
          toBeAdded = modelProductStandards.map(standard => {
            const standardData = standard?.standardId
              ? standard
              : (standard.otherProps ?? standard.value)
            return mapper(standardData)
          })

          if (toBeAdded.length > 0) {
            let lastSequence =
              +orderBy(
                model.originalProductStandards?.filter((standard: any) => standard.sequence),
                standard => +standard.sequence,
                'desc'
              )[0]?.sequence || 0

            toBeAdded.forEach(toBeAdd => (toBeAdd.seq = ++lastSequence))
          }
        } else {
          const originalStandardIds = model?.originalProductStandards?.map(
            (standard: any) => standard.code
          )

          toBeAdded = modelProductStandards
            .filter(
              standardList =>
                !originalStandardIds?.length || !originalStandardIds.includes(standardList.code)
            )
            .map(standard => {
              const standardData = standard?.standardId
                ? standard
                : (standard.otherProps ?? standard.value)
              return mapper(standardData)
            })

          if (toBeAdded.length > 0) {
            let lastSequence =
              +orderBy(
                model.originalProductStandards?.filter((standard: any) => standard.sequence),
                standard => +standard.sequence,
                'desc'
              )[0]?.sequence || 0

            toBeAdded.forEach(toBeAdd => (toBeAdd.seq = ++lastSequence))
          }

          toBeRemoved = (model.originalProductStandards ?? [])
            .filter(
              (originalStandard: any) =>
                !modelProductStandards.some(item => item.code === originalStandard.code)
            )
            .map(mapper)
        }

        return {
          assetId: [model.assetId],
          toBeAdded,
          toBeRemoved,
        }
      })
      .filter((item: any) => item.toBeAdded.length > 0 || item.toBeRemoved.length > 0)

    dispatch(
      setModelsProductStandardsUpdates(
        modelStandardUpdates.length <= 0 ? null : modelStandardUpdates
      )
    )
  }, [modelList])

  useEffect(() => {
    if (isEditCert && isModifyCert) return
    if (currentStep != 2) return
    if (models?.length > 0 && modelList?.length > 0) {
      let newProductStandardOptions = uniqBy(
        [...certProductStandardOptions, ...certSecondaryProductStandardOptions],
        standard => standard.code
      )

      var standardList = newProductStandardOptions.filter(
        x => standardValue?.includes(x.code) || secondaryStandardValue?.includes(x.code)
      )

      standardList.forEach((standard: any, i) => {
        const allModelsMissingStandard = modelList.every(
          (model: any) =>
            !(model.productStandards ?? []).some((ps: any) => ps.code === standard.code)
        )

        if (allModelsMissingStandard) {
          const newModelList = modelList.map((model: any) => {
            const newModel = { ...model }
            newModel.productStandards = uniqBy(
              [...(newModel.productStandards ?? []), standard],
              s => s.code
            )
            newModel.loadingProductStandards = false
            return newModel
          })

          setModelList(newModelList)
          return
        }
      })

      if (standardList.length < prevStandardLength) {
        const newModelList = modelList.map((model: any) => {
          const newModel = { ...model }
          newModel.productStandards = (newModel.productStandards ?? []).filter((ps: any) =>
            standardList.some(s => s.code === ps.code)
          )
          newModel.loadingProductStandards = false
          return newModel
        })
        setModelList(newModelList)
      }
      setPrevStandardLength(standardList.length)
    }
  }, [standardValue, secondaryStandardValue])

  const modelSecondaryStandardTemplate = (model: any) => {
    const isDisabled = isBatchEditMode ? !model.isForBatchEdit : !isModelSelected(model.assetId)

    return (
      <div
        onClick={event => event.stopPropagation()}
        className={classes['product-standards-container']}
      >
        <SecondaryStandardTemplate
          {...{
            isEditMode: model.isEditMode,
            isBatchEditMode,
            modelList,
          }}
          model={model}
          selectedModels={selectedModels}
          key={`${model.isEditMode || isBatchEditMode ? 'update' : 'static'}-${model.modelName}`}
          slotProps={{
            multiSelect: {
              className: classes['standards-dropdown'],
              disabled: isDisabled,
              onChange: (selectedValues: any) => {
                setModelsProductStandardsEditStates((prev: any) => {
                  const prevCopy = structuredClone(prev)
                  const toUpdate: any = prevCopy.find((item: any) => item.assetId === model.assetId)

                  if (!toUpdate) return prev
                  toUpdate.secondaryStandards = selectedValues
                  return prevCopy
                })
              },
            },
          }}
        />
      </div>
    )
  }

  const columns = [
    {
      id: 'modelName',
      value: 'Model',
      width: '20%',
      body: modelNameTemplate,
    },
    {
      id: 'productType',
      value: 'Product Type',
      width: '20%',
    },
    {
      id: 'productStandard',
      value: 'Product Standard',
      width: '25%',
      body: modelProductStandardsTemplate,
    },
    {
      id: 'secondaryStandard',
      value: 'Secondary Standard',
      width: '25%',
      body: modelSecondaryStandardTemplate,
    },
    {
      id: 'familySeries',
      value: 'Family / Series',
      width: '20%',
    },
    {
      id: 'status',
      value: 'Status',
      width: '10%',
    },
  ]

  const productExampleTemplate = ({ assetId, isForBatchEdit, modelName }: any) => (
    <ModelUploadColumn
      key={assetId}
      assetId={assetId}
      column={MODEL_UPLOAD_COLUMN.PRODUCT_EXAMPLE}
      isBatchEdit={isBatchEditMode}
      hasRowEditMode={hasRowEditMode}
      isForBatchEdit={isForBatchEdit}
      onUpdateColumnFile={updateColumFile}
      onAddColumnFile={addColumnFile}
      columnFiles={columnFiles}
      onDeleteColumnFile={deleteColumnFile}
      modelName={modelName}
    />
  )

  const nameplateTemplate = ({ assetId, isForBatchEdit, modelName }: any) => (
    <ModelUploadColumn
      key={assetId}
      assetId={assetId}
      column={MODEL_UPLOAD_COLUMN.NAME_PLATE}
      isBatchEdit={isBatchEditMode}
      hasRowEditMode={hasRowEditMode}
      isForBatchEdit={isForBatchEdit}
      onUpdateColumnFile={updateColumFile}
      onAddColumnFile={addColumnFile}
      columnFiles={columnFiles}
      onDeleteColumnFile={deleteColumnFile}
      modelName={modelName}
    />
  )

  if (isAnzCertificateScheme && !withoutImageColumns) {
    const anzColumns = [
      {
        id: 'nameplate',
        value: 'Nameplate',
        width: '16rem',
        body: nameplateTemplate,
      },
      {
        id: 'productExample',
        value: 'Product Example',
        width: '16rem',
        body: productExampleTemplate,
      },
    ]

    // insert after modelname column
    columns.splice(1, 0, ...anzColumns)
  }

  const onChangeRemarks = (event: any) => {
    setRemarks(event.target.value)
    dispatch(updateProdDetailsRemarks(event.target.value))
  }

  const dynamicColumns = columns
    .filter(col => {
      switch (col.id) {
        case 'secondaryStandard':
          return certHasSecondary
      }
      return true
    })
    .map(col => {
      const { id, value, width, ...rest } = col

      return (
        <Column key={id} columnKey={id} field={id} header={value} style={{ width }} {...rest} />
      )
    })

  const handleSelectedModelsApply = (selectedModels: any, isClose: any) => {
    dispatch(updateProdDetailsModelList(selectedModels))
    dispatch(updateHasExistingModels(false))
    dispatch(updateModelList(selectedModels))
    setModelList(selectedModels)

    if (isClose) setModelSearchVisible(false)
  }

  const onClickDeleteModelHeader = () => {
    setModelList((prevState: any) => {
      let newState: any = []

      prevState.forEach((item: any) => {
        let foundSelected = selectedModels.find((i: any) => i.assetId === item.assetId)
        if (!foundSelected) {
          newState.push(item)
        }
      })

      if (newState.length === 0) {
        const modelDetail = {
          partySiteNumber: partySiteNumberValue,
          productType: null,
          isDisable: false,
        }

        dispatch(updateModelDetails(modelDetail))
      }

      if (isAnzCertificateScheme && tempAssetDocu.length > 0) {
        const assetIds = selectedModels.map(i => i.assetId)
        const updatedAssetDocuments = tempAssetDocu.filter(
          (doc: AssetDocument) => !assetIds.includes(doc.data.entityId)
        )
        setColumnFiles((prev: any) => prev?.filter((p: any) => !assetIds.includes(p.assetId)))

        dispatch(deleteAssetDocuments(updatedAssetDocuments))
      }

      dispatch(updateProdDetailsModelList(newState))
      return newState
    })

    setSelectedModels([])
  }

  const onClickDeleteModelRow = (assetId: any) => {
    setModelList((prevState: any) => {
      const newState = prevState.filter((i: any) => i.assetId !== assetId)

      if (newState.length === 0) {
        const modelDetail = {
          partySiteNumber: partySiteNumberValue,
          productType: null,
          isDisable: false,
        }

        dispatch(updateModelDetails(modelDetail))
      }

      dispatch(updateProdDetailsModelList(newState))
      dispatch(updateModelList(newState))

      setSelectedModels(prevList => prevList.filter(m => m.assetId !== assetId))
      return newState
    })

    if (isAnzCertificateScheme) {
      const updatedAssetDocuments = tempAssetDocu.filter(
        (doc: AssetDocument) => doc.data.entityId !== (assetId as string)
      )
      setColumnFiles((prev: any) => prev?.filter((p: any) => p.assetId !== assetId))

      dispatch(deleteAssetDocuments(updatedAssetDocuments))
    }
  }

  const setEditMode = (isEditMode: any, model: any) => {
    if (isEditMode) {
      if (!selectedModels.some((selectedModel: any) => selectedModel.assetId === model.assetId)) {
        setSelectedModels(prevList => [...prevList, model])
      }

      updateModelProductStandardsEditState(model.assetId, model.productStandards)
    }

    setModelList((prevList: any) =>
      prevList.map((prevModel: any) => ({
        ...prevModel,
        isEditMode: prevModel.assetId === model.assetId ? isEditMode : prevModel.isEditMode,
      }))
    )

    setStandardList(standardOptions)
    // dispatch(updateStandardOptions(standardOptionsClone));
    dispatch(updateIsModelOnEdit(true))
  }

  const updateModelProductStandardsEditState = (assetId: any, newValues: any) => {
    if (modelsProductStandardsEditStates.some((model: any) => model.assetId === assetId)) {
      setModelsProductStandardsEditStates((prevList: any) =>
        prevList.map((item: any) => ({
          ...item,
          productStandards: item.assetId === assetId ? newValues : item.productStandards,
        }))
      )

      return
    }

    setModelsProductStandardsEditStates((prevList: any) => [
      ...prevList,
      { assetId, productStandards: newValues },
    ])
  }

  const handleModelProductStandardsEditChange = (
    e: any,
    newProductStandardOptions: any,
    assetId: any
  ) => {
    e.originalEvent.stopPropagation()
    const newValues = newProductStandardOptions.filter((option: any) =>
      e.value.includes(option.code)
    )

    updateModelProductStandardsEditState(assetId, newValues)
  }

  const getModelProductStandardsEditState = (assetId: any) =>
    (
      modelsProductStandardsEditStates.find((model: any) => model.assetId === assetId)
        ?.productStandards || []
    ).filter(ProductStandardUtils.filterListByStandard)

  const getModelProductSecondaryStandardsEditState = (assetId: any) =>
    (
      modelsProductStandardsEditStates.find((model: any) => model.assetId === assetId)
        ?.productStandards || []
    ).filter(ProductStandardUtils.filterListBySecondaryStandard)

  const certProductStandardOptions =
    certDetailsValues.standardOptions?.map((option: any) => ({
      ...option,
      ...option.otherProps,
    })) || []

  const certSecondaryProductStandardOptions =
    certDetailsValues.secondaryStandardOptions?.map((option: any) => ({
      ...option,
      ...option.otherProps,
    })) || []

  function setModelProductStandards(assetId: any, productStandards: any) {
    setModelList((previousList: any) =>
      previousList.map((prevModel: any) => ({
        ...prevModel,
        productStandards:
          prevModel.assetId === assetId ? productStandards : prevModel.productStandards,
        originalProductStandards:
          prevModel.assetId === assetId ? productStandards : prevModel.originalProductStandards,
      }))
    )
  }

  const handleProductStandardRemove = (assetId: any, code: any) => {
    const newProductStandards = getModelProductStandardsEditState(assetId).filter(
      (standard: any) => standard.code !== code
    )

    updateModelProductStandardsEditState(assetId, newProductStandards)
  }

  const selectedProductStandardTemplate = (assetId: any, productStandard: any) => {
    let selectedItemsCount = getModelProductStandardsEditState(assetId).length

    if (selectedItemsCount === 0 || !Boolean(productStandard)) {
      return (
        <span className={classes['product-standard__placeholder']}>
          {primaryStandardPlaceholder}
        </span>
      )
    }

    return (
      <div className={classes['product-standard--selected']}>
        <label>{productStandard?.name}</label>

        {productStandard?.name && (
          <button
            onClick={e => {
              e.stopPropagation()
              handleProductStandardRemove(assetId, productStandard.code)
            }}
          >
            {isModelSelected(assetId) && <FontAwesomeIcon icon={faClose} />}
          </button>
        )}
      </div>
    )
  }

  function modelNameTemplate(model: any) {
    if (model.isForBatchEdit) {
      return (
        <div className={classes['batch-edit-row-model-name']}>
          Note: Selected Product Standards in this row will apply <br></br>
          to all selected models.
        </div>
      )
    }

    return (
      <div className="flex flex-wrap items-center w-full">
        <div className="flex-1 min-w-0">
          <span className="break-words">{model.modelName}</span>
        </div>

        {model?.hasRating && (
          <div className="ml-2">
            <ProductRatingIcon model={model} />
          </div>
        )}
      </div>
    )
  }

  const primaryStandardPlaceholder = productType
    ? (standardOptions ?? []).length <= 0
      ? `None available for ${productType}`
      : '-- Select Product Standard(s) --'
    : ``

  function modelProductStandardsTemplate(model: any) {
    const modelStandard = (
      model.isForBatchEdit
        ? (modelList ?? []).flatMap((item: any) => item.productStandards)
        : (model.productStandards ?? [])
    )
      .filter(ProductStandardUtils.filterListByStandard)
      .map(ProductStandardUtils.mapStandardByValue)

    if (model.loadingProductStandards) {
      return (
        <div className={`${classes['product-standards-container--loading']}`}>
          <FontAwesomeIcon icon={faSpinner} spin={true} />
        </div>
      )
    }

    if (
      (model.isEditMode || isBatchEditMode) &&
      (selectedModels.map((x: any) => x.assetId).includes(model.assetId) || !model?.assetId)
    ) {
      let newProductStandardOptions = uniqBy(
        [...modelStandard, ...certProductStandardOptions],
        standard => standard.code
      )

      newProductStandardOptions = orderBy(newProductStandardOptions, ['name'], ['asc'])

      const isProductStandardsSelectionDisabled = isBatchEditMode
        ? !model.isForBatchEdit
        : !isModelSelected(model.assetId)

      let selectedValues = getModelProductStandardsEditState(model.assetId)

      return (
        <div
          className={`${classes['product-standards-container']}`}
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <MultiSelect
            ref={multiSelectRef}
            disabled={isProductStandardsSelectionDisabled}
            selectedItemTemplate={code => {
              const selectedProductStandard = newProductStandardOptions.find(
                standard => standard.code === code
              )

              return selectedProductStandardTemplate(model.assetId, selectedProductStandard)
            }}
            onChange={e => {
              handleModelProductStandardsEditChange(e, newProductStandardOptions, model.assetId)
            }}
            value={selectedValues.map((standard: any) => standard.code)}
            filter={true}
            optionLabel="name"
            optionValue="code"
            options={newProductStandardOptions}
            placeholder={primaryStandardPlaceholder}
            className={`${classes['standards-dropdown']}`}
            appendTo={'self'}
            panelClassName={classes['model-section-standard-panel']}
            onShow={() => {
              const overlay = multiSelectRef.current?.getOverlay?.()
              const row = multiSelectRef.current?.getElement()?.closest('tr')

              if (overlay) {
                row?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                })
              }
            }}
          />
        </div>
      )
    }

    const productStandardsTooltip = modelStandard
      ?.map((productStandard: any) => productStandard.name)
      .join(' \n')

    const maxDisplay = 5
    const sortedProductStandards = sortList(modelStandard || [], 'name', 1) || []
    const topSortedProductStandards = [...sortedProductStandards].slice(0, maxDisplay)

    return (
      <div className={`${classes['product-standards-container']}`} title={productStandardsTooltip}>
        {topSortedProductStandards.map(productStandard => (
          <div key={productStandard.code}>{productStandard.name}</div>
        ))}
      </div>
    )
  }

  const handleEditHeaderClick = () => {
    const selectedModelsProductStandards = flatten(
      selectedModels.map((x: any) => x.productStandards)
    )

    const uniqueSelectedProductStandards = uniqBy(
      selectedModelsProductStandards,
      standard => standard.code
    )

    updateModelProductStandardsEditState(undefined, uniqueSelectedProductStandards)

    modelList.forEach((model: any) =>
      updateModelProductStandardsEditState(model.assetId, model.productStandards)
    )
    setIsBatchEditMode(true)

    setStandardList(standardOptions)
    // dispatch(updateStandardOptions(standardOptionsClone));
    dispatch(updateIsModelOnEdit(true))
  }

  const renderModelsActionsHeader = () => {
    const isSelectedMoreThan1 = selectedModels?.length > 1
    const isBatchActionsDisabled = !isSelectedMoreThan1 || hasRowEditMode

    return (
      <div className={`${classes['actions-container']} ${classes['actions-container--header']}`}>
        <button
          title="Edit Selected"
          disabled={isBatchActionsDisabled}
          onClick={handleEditHeaderClick}
          className={classes['action-button']}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>

        <button
          title="Delete Selected"
          disabled={isBatchActionsDisabled}
          className={classes['action-button']}
          onClick={onClickDeleteModelHeader}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    )
  }

  const handleBulkSaveRowsEdit = () => {
    if (modelList.length !== selectedModels.length) {
      setBulkSaveConfirmationDialogVisible(true)
      setPendingBulkSaveEditModesConfirmation(models)
      return
    }

    handleSaveRowsEdit(selectedModels)
  }

  const handleBulkSaveConfirmationConfirm = () => {
    setBulkSaveConfirmationDialogVisible(false)
    handleSaveRowsEdit(pendingBulkSaveEditModesConfirmation)
  }

  const handleBulkSaveConfirmationNoCancel = () => {
    setBulkSaveConfirmationDialogVisible(false)
  }

  const handleCloseRowEditMode = (models: any) => {
    setCloseRowEditModeConfirmationDialogVisible(true)
    setPendingCloseRowsEditModesConfirmation(models)
  }

  const handleSaveRowsEdit = (models: any) => {
    models.forEach((model: any) => {
      setEditMode(false, model)

      if (!isModelSelected(model.assetId)) return

      const assetId = isBatchEditMode ? undefined : model.assetId

      const modelProductStandards: any = modelsProductStandardsEditStates.find(
        (item: any) => item.assetId === assetId
      )

      const secondaryStandardChanges =
        modelProductStandards.secondaryStandards ?? // not undefined once secondary has changes
        (model.productStandards ?? [])
          .filter(ProductStandardUtils.filterListBySecondaryStandard)
          .map(ProductStandardUtils.mapStandardByValue) // retain original secondary values;

      const newProductStandards = (modelProductStandards?.productStandards ?? [])
        .filter(ProductStandardUtils.filterListByStandard)
        .map(ProductStandardUtils.mapStandardByValue)

      setModelList((previousList: any) => {
        const newModelList = previousList.map((prevModel: any) => ({
          ...prevModel,
          productStandards:
            prevModel.assetId === model.assetId
              ? uniqBy(
                  [
                    ...newProductStandards,
                    ...secondaryStandardChanges.filter((item: any) =>
                      (secondaryStandardOptions ?? []).some(
                        (option: any) => item.code === option.code
                      )
                    ), // catch not iterable exception
                  ],
                  'code'
                )
              : prevModel.productStandards,
        }))

        const newCertificateProductStandards = props.isCertificateHaveStandard
          ? uniqBy(
              newModelList.flatMap((model: any) => model.productStandards || []),
              'code'
            )
          : null

        //#region sync all model standards
        const standardsUpdate = props.isCertificateHaveStandard
          ? newProductStandards.map((item: any) => item.code)
          : []
        const secondaryStandardsUpdate = secondaryStandardChanges.map((item: any) => item.code)

        const prevProductStandards = newModelList.flatMap(
          (item: any) => item.productStandards ?? []
        )
        const prevStandards = prevProductStandards
          .filter(ProductStandardUtils.filterListByStandard)
          .map(ProductStandardUtils.mapStandardByValue)
          .map((item: any) => item.code)
        const prevSecondaryStandards = prevProductStandards
          .filter(ProductStandardUtils.filterListBySecondaryStandard)
          .map(ProductStandardUtils.mapStandardByValue)
          .map((item: any) => item.code)

        const newStandards = [...new Set([...standardsUpdate, ...prevStandards])]

        const newSecondaryStandards = [
          ...new Set([...secondaryStandardsUpdate, ...prevSecondaryStandards]),
        ]
        //#endregion

        setFormValues((prevState: any) => {
          const newState = {
            ...prevState,
            [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard')]: newStandards,
            [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'secondaryStandard')]:
              newSecondaryStandards,
          }

          dispatch(updateCertDetailsFormValues(newState))
          return newState
        })

        setFormValidityMessages((prevState: any) => {
          let newState = JSON.parse(JSON.stringify(prevState))
          newState[getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard')] = ''
          return newState
        })

        const newCertProductStandardOptions = uniqBy(
          [...certProductStandardOptions, ...(newCertificateProductStandards ?? [])],
          option => option.code
        )

        dispatch(updateStandardValues(newStandards))
        dispatch(updateSecondaryStandardValues(newSecondaryStandards))

        // dispatch(updateStandardOptions(newCertProductStandardOptions));
        dispatch(updateTempStandardOptions(newCertProductStandardOptions))
        dispatch(updateTempSecondaryStandardOptions(secondaryStandardOptions))

        return newModelList
      })
    })

    unselectModels(models)
    setPendingBulkSaveEditModesConfirmation([])
    setIsBatchEditMode(false)
    dispatch(updateIsModelOnEdit(false))
  }

  const actionsRowTemplate = (model: any) => {
    const isEditModeDisabled = !isModelSelected(model.assetId) && !model.isForBatchEdit

    const isSaveProductStandardsDisabled = model.isForBatchEdit && selectedModels.length === 0

    return (
      <div className={classes['actions-container']}>
        {model.isEditMode && (
          <>
            <button
              title="Save"
              onClick={e => {
                if (isSaveProductStandardsDisabled) return
                onProductStandardRowEditClick(e, model, false)
              }}
              className={`${classes['action-button']} ${classes['btn-edit-mode--check']} ${
                isEditModeDisabled || isSaveProductStandardsDisabled
                  ? classes['btn-edit-mode--check-disabled']
                  : ''
              }`}
            >
              <FontAwesomeIcon size="lg" icon={faCheck} />
            </button>

            <button
              title="Cancel"
              onClick={e => onProductStandardRowEditClick(e, model, true)}
              className={`${classes['action-button']} ${classes['btn-edit-mode--close']} ${
                isEditModeDisabled ? classes['btn-edit-mode--check-disabled'] : ''
              }`}
            >
              <FontAwesomeIcon size="lg" icon={faClose} />
            </button>
          </>
        )}

        {!model.isEditMode && !isBatchEditMode && (
          <button
            title="Edit Product Standard"
            onClick={e => {
              e.stopPropagation()
              setEditMode(true, model)
            }}
            disabled={selectedModels?.length > 1}
            className={classes['action-button']}
          >
            <FontAwesomeIcon icon={faPencil} />
          </button>
        )}

        {!model.isForBatchEdit && !isBatchEditMode && !model.isEditMode && (
          <button
            title="Delete Model"
            className={classes['action-button']}
            disabled={selectedModels?.length > 1}
            onClick={e => {
              e.stopPropagation()
              onClickDeleteModelRow(model.assetId)
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        )}
      </div>
    )
  }

  const hasModel = modelList?.length > 0

  const onProductStandardRowEditClick = (event: any, model: any, isClose: any) => {
    event.stopPropagation()

    if (!isModelSelected(model.assetId) && !model.isForBatchEdit) return

    if (isClose) {
      handleCloseRowEditMode([model])
      return
    }

    if (model.isForBatchEdit) {
      handleBulkSaveRowsEdit()
      return
    }

    handleSaveRowsEdit([model])
  }

  const handleCloseRowEditModeConfirmationConfirm = () => {
    setCloseRowEditModeConfirmationDialogVisible(false)

    pendingCloseRowsEditModesConfirmation.forEach(row => {
      setEditMode(false, row)
    })

    // dispatch(updateStandardOptions(standardList));
    unselectModels(pendingCloseRowsEditModesConfirmation)
    setIsBatchEditMode(false)
    dispatch(updateIsModelOnEdit(false))
  }

  const unselectModels = (models: any) => {
    setSelectedModels(prevSelectedModels =>
      prevSelectedModels.filter(
        (selectedModel: any) =>
          !models.map((model: any) => model.assetId).includes(selectedModel.assetId)
      )
    )
  }

  const handleCloseRowEditModeConfirmationNoCancel = () => {
    setCloseRowEditModeConfirmationDialogVisible(false)
  }

  const isModelSelected = (assetId: any) => {
    if (selectedModels.length === 0) return

    return selectedModels.some((selectedModel: any) => selectedModel.assetId === assetId)
  }

  const isModelSelectable = (model: any) => {
    return !model.data.isForBatchEdit
  }

  const frozenRows = isBatchEditMode ? [batchEditRowData] : []

  const isCertificateFromRevision = () => {
    return isEditCert && (hasRevisions || isModifyCert)
  }

  const handleModelSelectionChange = (e: any) => {
    if (!hasRowEditMode) setSelectedModels(e.value)
    else if (isBatchEditMode) setSelectedModels(e.value)
  }

  const isEditOrModify = isEditCert || isModifyCert

  return (
    <>
      <Toast ref={toast} />
      <CloseRowEditModeConfirmationDialog
        onCancel={handleCloseRowEditModeConfirmationNoCancel}
        onConfirm={handleCloseRowEditModeConfirmationConfirm}
        visible={closeRowEditModeConfirmationDialogVisible}
        maskClassName={classes['custom-dialog']}
      />

      <BulkSaveConfirmationDialog
        selectedModelsCount={selectedModelsCount}
        onCancel={handleBulkSaveConfirmationNoCancel}
        onConfirm={handleBulkSaveConfirmationConfirm}
        visible={bulkSaveConfirmationDialogVisible}
        maskClassName={classes['custom-dialog']}
      />

      <ModelSearch
        visible={modelSearchVisible}
        onClose={() => setModelSearchVisible(false)}
        onSelectedModelsApply={handleSelectedModelsApply}
        partySiteNumber={
          hasModel
            ? modelList[0].taxonomy.find(
                (m: any) => m.dataParamName === 'ownerReference_PartySiteID'
              ).value
            : modelDetailValues?.partySiteNumber
        }
        productType={hasModel ? modelList[0].productType : modelDetailValues?.productType}
        disablePsn={hasModel}
        disableProductType={hasModel}
        preSelectedModels={modelList}
        certificateId={certificateId}
      />

      <div
        className={
          isSavingCertificate ? 'display-none' : classes['add-new-cert-prod-details-modal']
        }
      >
        {/* from here */}
        <div className={classes['add-new-cert-prod-details-header']}>
          <span>Click "Select Model" button to add models&nbsp;&nbsp;</span>
          <span>
            <button
              disabled={hasRowEditMode}
              className={`ul-button -app-tertiary -medium ${classes['select-model-btn']}`}
              onClick={() => setModelSearchVisible(true)}
            >
              SELECT MODEL
            </button>
          </span>
        </div>

        <div>
          <div className={classes['models-table__header']}>
            <div className={classes['new-cert-prod-dtls-col-hdr']}>
              Current List of Models
              {selectedModelsCount > 1 && ` | (${selectedModelsCount}) Models Selected`}
              {isAnzCertificateScheme && !withoutImageColumns && (
                <>
                  |
                  <span style={{ fontStyle: 'italic' }}>
                    <span style={{ fontWeight: 'bold' }}>Note:</span>
                    <span style={{ fontWeight: 'normal' }}>
                      &nbsp; For Nameplate and Product Example image upload - Maximum upload file
                      size: (1MB) | Allowed file type: (JPEG, PNG)
                    </span>
                  </span>
                </>
              )}
            </div>

            {renderModelsActionsHeader()}
          </div>

          <div className={`new-cert-prod-dtls-col-override ${classes['models-list-container']}`}>
            <DataTable
              size="small"
              tableStyle={{ overflowY: 'scroll' }}
              scrollable
              removableSort
              // scrollHeight="390px"
              scrollDirection="both"
              value={modelList}
              emptyMessage="No available options"
              columnResizeMode="expand"
              responsiveLayout="scroll"
              dataKey="assetId"
              selection={selectedModels}
              isDataSelectable={isModelSelectable}
              className={classes['new-cert-prod-dtls-col-tbl']}
              onSelectionChange={(e: any) => handleModelSelectionChange(e)}
              rowClassName={(model: any) => {
                if (!model.isEditMode && hasRowEditMode) {
                  return classes['row--disabled']
                }
                return ''
              }}
              frozenValue={frozenRows}
              // style={{height: "21rem !important"}}
            >
              <Column
                selectionMode="multiple"
                alignFrozen="left"
                frozen
                headerStyle={{
                  pointerEvents: rowsInEditMode?.length === 1 ? 'none' : 'auto',
                }}
                className={rowsInEditMode?.length > 0 ? classes['row--disabled'] : ''}
              ></Column>
              {dynamicColumns}
              <Column
                frozen
                alignFrozen="right"
                header={<div style={{ minWidth: '98px' }}> </div>}
                style={{ width: 'fit-content', paddingRight: '0.25rem' }}
                body={actionsRowTemplate}
              />
            </DataTable>
          </div>
        </div>
        {/* up till here */}
      </div>
    </>
  )
}

export default CertificateModelSection
